import { Skeleton } from "@/web/components/primitives/skeleton";

export function GenericCardLoader() {
  return (
    <div>
      <Skeleton className="h-[440px] w-full rounded-none" />
    </div>
  );
}
